import Module from '../../utils/modules/Module';
import EventsManager from '../../utils/events/EventsManager';
import CustomEvents from '../../utils/events/CustomEvents';

export default class GalleryModule extends Module {
  constructor(options) {
    super(options)

    this.DOMEl = options.element;
    this.html = document.querySelector('html');
    this.modal = this.DOMEl.querySelector('.gallery-modal');
    this.imagesBtn = this.DOMEl.querySelectorAll('.gallery-btn');
    this.onClickLoadMore = this.onClickLoadMore.bind(this);
    this.onClickCloseModal = this.onClickCloseModal.bind(this);
    this.onClickOpenModal = this.onClickOpenModal.bind(this);
    this.init();
  }

  init() {
    this.imagesBtn.forEach((el) => {
      el.addEventListener('click', this.onClickOpenModal);
    });

    if(this.DOMEl.querySelector('.gallery-close')) {
      this.DOMEl.querySelector('.gallery-close').addEventListener('click', this.onClickCloseModal);
    }

    if(this.DOMEl.querySelector('.gallery-more')) {
      this.DOMEl.querySelector('.gallery-more').addEventListener('click', this.onClickLoadMore);
    }

    this.prepGallery();
  }

  /** ------------------------------
   * Events
   --------------------------------- */

  /**
   * Prepare the gallery for the load more if there's more than 6 items in total
   */
  prepGallery() {
    let otherImages = this.DOMEl.querySelectorAll('.gallery-item.hide');
    otherImages.forEach((el) => {
      el.classList.remove('hide');
    });
    const otherImagesArray = Array.from(otherImages);
    const groupedImages = [];

    if (otherImagesArray.length === 7 || otherImagesArray.length === 8) {
      groupedImages.push(otherImagesArray);
    }
    else {
      // Divide other images in group of 6
      for (let i = 0; i < otherImagesArray.length; i += 6) {
        groupedImages.push(otherImagesArray.slice(i, i + 6));
      }
    }

    // Put each group in a <ul>
    groupedImages.forEach(group => {
      const ul = document.createElement('ul');
      ul.classList.add('gallery-list', 'gallery-list-loaded', 'gallery-list-'+group.length, 'hide');
      group.forEach(item => {
        ul.appendChild(item);
      });

      // Add list to the grid
      this.DOMEl.querySelector('.gallery-grid').appendChild(ul);
    });

    // Show copyrights in slider
    this.modal.querySelectorAll('.media-credit').forEach((el) => {
      el.removeAttribute('hidden');
    });
  }


  /**
   * Load more images in the grid gallery
   * 6 images max are loaded at a time
   * @param e
   */
  onClickLoadMore(e) {
    let $el = e.currentTarget;
    let $parent = $el.closest('.gallery');

    if ($parent.querySelectorAll('.gallery-list.hide').length > 0) {
      $parent.querySelector('.gallery-list.hide').classList.remove('hide');

      if ($parent.querySelectorAll('.gallery-list.hide').length === 0) {
        $el.classList.add('hide');
      }
    }
  }


  /**
   * Open the modal
   * @param e - click event
   */
  onClickOpenModal(e) {
    e.currentTarget.classList.add('active');
    this.modal.showModal();
    this.html.classList.add('no-scroll');

    // used to refresh sliders
    EventsManager.broadcast(CustomEvents.modal.MODAL_OPEN);
  }


  /**
   * Close the modal
   * @param e - click event
   */
  onClickCloseModal(e) {

    this.modal.close();
    this.html.classList.remove('no-scroll');
    this.imagesBtn.forEach((el) => {
      el.classList.remove('active');
    });

    EventsManager.broadcast(CustomEvents.modal.MODAL_CLOSE);
  }

}
